import { useContext, useRef, MouseEvent, useState } from "react";
import { DateFormat, formatDate } from "../../utils/datePareser";
import { PartyModel } from "../../types";
import { AlsoGoingOutSelectedGroupContext } from "../../GlobalContext/selectedAlsoGoingOutGroupContext";
import { iconsImgs } from "../../utils/icons";
import Gender from "../../api/enums/Gender";
import { routes } from "../../routes/routes";
import { Link } from "react-router-dom";
import { getUserAvatar } from "../../utils/getMedia";
import AuthClient from "../../api/AuthClient";
import handleImgError from "../../handleImgError";

interface Props {
    authClient: AuthClient;
    alsoGoingOutGroups: PartyModel[]
    group: PartyModel
}

const AlsoGoingOutGroupDetail: React.FC<Props> = ({ authClient, alsoGoingOutGroups, group }) => {

    const { setSelectedAlsoGoingOutGroup } = useContext(AlsoGoingOutSelectedGroupContext);

    const containerRef = useRef<HTMLDivElement>(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const dragOriginXRef = useRef(0);
    const dragDistanceRef = useRef(0);
    const DRAG_THRESHOLD_PX = 5;

    const formattedDate = (inputDateString: Date, inCludeTime: boolean): string => {
        return formatDate(new Date(inputDateString), inCludeTime, DateFormat.Short);
    };

    const handleClickInvitation = (groupInvitation: PartyModel) => {

        const selectedGroup = alsoGoingOutGroups?.find(
            (group) => group.party.id === groupInvitation.party.id
        );

        if (selectedGroup) {
            setSelectedAlsoGoingOutGroup(selectedGroup.invitations, [selectedGroup?.party], selectedGroup.requestedListings, selectedGroup.promotersOffers);
        }
    };

    const onMouseDown = (event: MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        setIsDragging(true);
        setStartX(event.clientX);
        dragOriginXRef.current = event.clientX;
        dragDistanceRef.current = 0;
    };

    const onMouseMove = (event: MouseEvent<HTMLDivElement>) => {
        if (!isDragging || !containerRef.current) return;
        const deltaX = event.clientX - startX;
        containerRef.current.scrollLeft -= deltaX;
        setStartX(event.clientX);
        dragDistanceRef.current = Math.abs(event.clientX - dragOriginXRef.current);
    };

    const onMouseLeave = () => {
        setIsDragging(false);
    };

    const handlePhotoClick = (e: React.MouseEvent) => {
        if (dragDistanceRef.current > DRAG_THRESHOLD_PX) {
            e.preventDefault();
            return;
        }
        handleClickInvitation(group);
    };

    return (
        <>
            <div className="groupPromoter mb-3">
                <Link
                    to={routes.AlsoGoingOutDetailPage(group.party.id)}
                    onClick={handlePhotoClick}
                    className="groupPromoterLink"
                >
                <div className="desktopUI">
                    <div className="datePm d-flex align-items-center w-100">
                        <p> {formattedDate(group.party.partyDate, false)} </p>
                    </div>

                    <div className=" text-center row align-items-start">
                        <div className="guestListTitle greyBorder col">
                            <p className="mt-2">{group.party.bookingType}</p>
                        </div>

                        <div className="yellowTxt greyBorder align-content-center justify-content-center  d-flex col">
                            <p className="mt-3 mb-2">
                                {
                                    group.invitations.filter(
                                        (invitation) => (Gender[invitation.gender]).toString() === Gender.Female.toString()
                                    ).length
                                }
                            </p>
                            <img src={iconsImgs.Female} alt="" className="mt-3 Icons" />
                            <p className="mt-3 mb-2 ">
                                {
                                    group.invitations.filter(
                                        (invitation) => (Gender[invitation.gender]).toString() === Gender.Male.toString()
                                    ).length
                                }
                            </p>
                            <img src={iconsImgs.Male} alt="" className="mt-3 Icons" />
                        </div>

                        <div className="dateCreated greyBorder d-flex flex-column col">
                            <p>Created</p>
                            <p>
                                {formattedDate(group.party.createdAt, true)}
                            </p>
                        </div>
                    </div>

                    <div className=" text-center row  mt-2 agesGroup">
                        <p className="d-flex fw-semibold col-auto me-1 ms-2">Ages:</p>
                        <p className="d-flex yellowTxt col-auto p-0">
                            {group.invitations
                                .map((invitation) => invitation.age)
                                .sort((a, b) => a - b)
                                .join(", ")}
                        </p>
                    </div>

                    <div className="d-flex invContainer" ref={containerRef}
                        onMouseDown={onMouseDown}
                        onMouseMove={onMouseMove}
                        onMouseLeave={onMouseLeave}
                        onMouseUp={onMouseLeave}
                        style={{ cursor: isDragging ? 'grabbing' : 'grab' }}>
                        {group.invitations.map((invitation: any) => (
                            <div key={invitation.id} className="ps-2 linkContainer">
                                <img
                                    src={getUserAvatar(`${invitation?.id!}?${Date.now()}`)}
                                    alt="Profile Image"
                                    className="imgGuestA"
                                    onError={(event) => { handleImgError(event, invitation.gender.toString()) }}
                                    style={{ cursor: 'default' }}
                                />
                            </div>
                        ))}
                    </div>

                    <div className=" mt-2 row">
                        <p className="d-flex fw-semibold col-auto me-1 ms-2 mb-0">Requested:</p>
                        <p className="d-flex col-auto yellowTxt p-0 m-0">
                            {group.requestedListings.map((listing) => listing.clubName)}
                        </p>
                    </div>
                    {group.promotersOffers.length > 0 ?
                        <div className="row">
                            <p className="d-flex fw-semibold col-auto me-1 ms-2">Sent:</p>
                            <p className="d-flex col-auto yellowTxt p-0">
                                {group.promotersOffers.map((listing) => listing.offers.map((offer) => offer.clubName).join(", "))}
                            </p>
                        </div> : ""
                    }
                </div>
                </Link>
            </div>
        </>
    );
}

export default AlsoGoingOutGroupDetail;